import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import cupIcon from './files/cup_bug.png';
import vanIcon from './files/van.png';
import './Navigation.css';

function Navigation({ activeSection, setActiveSection }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home', icon: cupIcon },
    { id: 'tour', label: 'Tour', icon: vanIcon },
    { id: 'author', label: 'Author', icon: 'person' },
    { id: 'contact', label: 'Contact', icon: 'mail' },
    { id: 'podcast', label: 'Podcast', icon: 'podcast', external: 'https://podcasts.apple.com/us/podcast/love-works-here/id1466029074' }
  ];

  const activeIndex = navItems.findIndex(item => item.id === activeSection);

  const handleNavClick = (item) => {
    if (item.external) {
      window.open(item.external, '_blank', 'noopener,noreferrer');
    } else {
      setActiveSection(item.id);
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      <button
        className={`hamburger-button ${isMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle navigation menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="mobile-menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsMenuOpen(false)}
          />
        )}
      </AnimatePresence>

      <motion.nav
        className={`navigation ${isMenuOpen ? 'mobile-open' : ''}`}
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
      <ul className="nav-links">
        <motion.div
          className="nav-indicator"
          animate={{ y: activeIndex * 50 }}
          transition={{ type: 'spring', stiffness: 350, damping: 25 }}
        >
          {activeIndex >= 0 && (
            ['person', 'plane', 'podcast', 'pillar', 'mail'].includes(navItems[activeIndex].icon) ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#DC143C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {navItems[activeIndex].icon === 'person' && (
                  <>
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </>
                )}
                {navItems[activeIndex].icon === 'plane' && (
                  <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
                )}
                {navItems[activeIndex].icon === 'podcast' && (
                  <>
                    <circle cx="12" cy="11" r="1"></circle>
                    <path d="M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z"></path>
                    <path d="M8 14a5 5 0 1 1 8 0"></path>
                    <path d="M17 7A7 7 0 1 0 7 7"></path>
                  </>
                )}
                {navItems[activeIndex].icon === 'pillar' && (
                  <>
                    <path d="M3 9l9-5 9 5"></path>
                    <path d="M5 9h14"></path>
                    <path d="M4 20h16"></path>
                    <path d="M6 9v11"></path>
                    <path d="M9 9v11"></path>
                    <path d="M12 9v11"></path>
                    <path d="M15 9v11"></path>
                    <path d="M18 9v11"></path>
                  </>
                )}
                {navItems[activeIndex].icon === 'mail' && (
                  <>
                    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </>
                )}
              </svg>
            ) : (
              <img
                src={navItems[activeIndex].icon}
                alt="Active"
                className={navItems[activeIndex].icon === vanIcon ? 'van-icon' : 'cup-icon'}
              />
            )
          )}
        </motion.div>
        {navItems.map((item) => (
          <li
            key={item.id}
            onClick={() => handleNavClick(item)}
            className={activeSection === item.id ? 'active' : ''}
          >
            <span className="nav-label">{item.label}</span>
          </li>
        ))}
      </ul>
    </motion.nav>
    </>
  );
}

export default Navigation;
